// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/core/svc_organization.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { Empty, proto3 } from "@bufbuild/protobuf";
import { Organization, OrganizationContacts, OrganizationSettings, OrganizationStorageSize, OrganizationType } from "../../model/dto_organization_pb.js";
import { OrganizationStaff } from "../../model/dto_organization_staff_pb.js";
import { OrganizationJobPosition } from "../../model/dto_organization_job_position_pb.js";

/**
 * @generated from message com.diagnocat.core.OrganizationSettingsStreamReq
 */
export const OrganizationSettingsStreamReq = proto3.makeMessageType(
  "com.diagnocat.core.OrganizationSettingsStreamReq",
  () => [
    { no: 2, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.OrganizationSettingsStreamResp
 */
export const OrganizationSettingsStreamResp = proto3.makeMessageType(
  "com.diagnocat.core.OrganizationSettingsStreamResp",
  () => [
    { no: 11, name: "HistoricalOrganization", kind: "message", T: Organization, oneof: "Update" },
    { no: 12, name: "HistoricalOrganizationStorageSize", kind: "message", T: OrganizationStorageSize, oneof: "Update" },
    { no: 13, name: "HistoricalOrganizationStaff", kind: "message", T: OrganizationStaff, oneof: "Update" },
    { no: 14, name: "EndOfHistoricalOrganizationStaff", kind: "message", T: Empty, oneof: "Update" },
    { no: 15, name: "HistoricalParentDSOOrganization", kind: "message", T: Organization, oneof: "Update" },
    { no: 21, name: "UpdatedOrganization", kind: "message", T: Organization, oneof: "Update" },
    { no: 22, name: "UpdatedOrganizationStorageSize", kind: "message", T: OrganizationStorageSize, oneof: "Update" },
    { no: 23, name: "UpdatedOrganizationStaff", kind: "message", T: OrganizationStaff, oneof: "Update" },
    { no: 24, name: "UpdatedParentDSOOrganization", kind: "message", T: Organization, oneof: "Update" },
    { no: 101, name: "Ping", kind: "message", T: Empty, oneof: "Update" },
  ],
);

/**
 * @generated from message com.diagnocat.core.CreateOrganizationReq
 */
export const CreateOrganizationReq = proto3.makeMessageType(
  "com.diagnocat.core.CreateOrganizationReq",
  () => [
    { no: 1, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Type", kind: "enum", T: proto3.getEnumType(OrganizationType) },
    { no: 4, name: "Contacts", kind: "message", T: OrganizationContacts, opt: true },
    { no: 5, name: "IsDSO", kind: "message", T: Empty, oneof: "Affiliation" },
    { no: 6, name: "DSOParentID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Affiliation" },
    { no: 7, name: "IsDistributor", kind: "message", T: Empty, oneof: "Affiliation" },
    { no: 8, name: "DistributorParentID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Affiliation" },
    { no: 11, name: "OwnerID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Owner" },
    { no: 12, name: "NewOwnerData", kind: "message", T: CreateOrganizationReq_NewOwner, oneof: "Owner" },
  ],
);

/**
 * `NewOwner`: data required to create an owner user when the owner does not exist yet
 *
 * @generated from message com.diagnocat.core.CreateOrganizationReq.NewOwner
 */
export const CreateOrganizationReq_NewOwner = proto3.makeMessageType(
  "com.diagnocat.core.CreateOrganizationReq.NewOwner",
  () => [
    { no: 1, name: "Email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "FirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "LastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "CreateOrganizationReq_NewOwner"},
);

/**
 * @generated from message com.diagnocat.core.CreateOrganizationResp
 */
export const CreateOrganizationResp = proto3.makeMessageType(
  "com.diagnocat.core.CreateOrganizationResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
    { no: 2, name: "Staff", kind: "message", T: OrganizationStaff },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationNameReq
 */
export const SetOrganizationNameReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationNameReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationNameResp
 */
export const SetOrganizationNameResp = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationNameResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationPrintNameReq
 */
export const SetOrganizationPrintNameReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationPrintNameReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "PrintName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationPrintNameResp
 */
export const SetOrganizationPrintNameResp = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationPrintNameResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationContactsReq
 */
export const SetOrganizationContactsReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationContactsReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Contacts", kind: "message", T: OrganizationContacts },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationContactsResp
 */
export const SetOrganizationContactsResp = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationContactsResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationSettingsReq
 */
export const SetOrganizationSettingsReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationSettingsReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Settings", kind: "message", T: OrganizationSettings },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationSettingsResp
 */
export const SetOrganizationSettingsResp = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationSettingsResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationMFARequirementReq
 */
export const SetOrganizationMFARequirementReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationMFARequirementReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationStaffMFARequirementReq
 */
export const SetOrganizationStaffMFARequirementReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationStaffMFARequirementReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "StaffID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationLanguageReq
 */
export const SetOrganizationLanguageReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationLanguageReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationLanguageResp
 */
export const SetOrganizationLanguageResp = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationLanguageResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationCommentReq
 */
export const SetOrganizationCommentReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationCommentReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Comment", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationCommentResp
 */
export const SetOrganizationCommentResp = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationCommentResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
  ],
);

/**
 * @generated from message com.diagnocat.core.DeleteOrganizationReq
 */
export const DeleteOrganizationReq = proto3.makeMessageType(
  "com.diagnocat.core.DeleteOrganizationReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.DeleteOrganizationResp
 */
export const DeleteOrganizationResp = proto3.makeMessageType(
  "com.diagnocat.core.DeleteOrganizationResp",
  () => [
    { no: 1, name: "DeletedOrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationStaffJobPositionsReq
 */
export const SetOrganizationStaffJobPositionsReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationStaffJobPositionsReq",
  () => [
    { no: 1, name: "StaffID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "JobPositions", kind: "enum", T: proto3.getEnumType(OrganizationJobPosition), repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationStaffJobPositionsResp
 */
export const SetOrganizationStaffJobPositionsResp = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationStaffJobPositionsResp",
  () => [
    { no: 1, name: "Staff", kind: "message", T: OrganizationStaff },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationStaffNameReq
 */
export const SetOrganizationStaffNameReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationStaffNameReq",
  () => [
    { no: 1, name: "StaffID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "FirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "LastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationStaffNameResp
 */
export const SetOrganizationStaffNameResp = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationStaffNameResp",
  () => [
    { no: 1, name: "Staff", kind: "message", T: OrganizationStaff },
  ],
);

